export class IdentityProviderInfo {
  name: string;
  displayName: string;
  buttonIconUrl: string;
  buttonBackgroundColor: string;
  buttonTextColor: string;

  constructor(idpInfo: config.IdentityProviderInfo) {
    this.name = idpInfo.Name;
    this.displayName = idpInfo.DisplayName;
    this.buttonIconUrl = idpInfo.ButtonIconUrl;
    this.buttonBackgroundColor = idpInfo.ButtonBackgroundColor;
    this.buttonTextColor = idpInfo.ButtonTextColor;
  }
}
